import {OmniObject} from './objects';

export default class OmniFactory {
  classes = {};

  constructor() {
    this.registerClass('OmniObject', OmniObject);
  }

  /**
   * Define classes that this factory can instantiate
   *
   * @param {Object} classes The classes to register
   * @example {
   *    Image: OmniImage,
   *    Text: OmniText
   * }
   */
  registerMultiple(classes) {
    Object.keys(classes).forEach(className => {
      const classDefinition = classes[className];
      this.registerClass(className, classDefinition);
    });
  }

  registerClass(className, classDefinition) {
    this.classes[className] = classDefinition;
  }

  instantiate(className, options) {
    if (this.classes[className]) {
      return new this.classes[className](options);
    }

    return new OmniObject(options);
  }
}
